import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3b9bd133"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "indicator" };
const _hoisted_2 = { class: "tooltip" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-calendar mr-1" }, null, -1));
const _hoisted_5 = { key: 1 };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-times mr-1" }, null, -1));
const _hoisted_7 = { key: 2 };
const _hoisted_8 = { class: "is-flex is-align-items-center" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-calendar mr-1" }, null, -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "is-flex-grow-1" }, null, -1));
const _hoisted_11 = { class: "timeDescriptor" };
const _hoisted_12 = {
    key: 0,
    class: "is-flex is-align-items-center"
};
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "is-flex-grow-1" }, null, -1));
const _hoisted_14 = { class: "timeDescriptor" };
const _hoisted_15 = { key: 3 };
const _hoisted_16 = {
    key: 0,
    class: "is-flex is-align-items-center"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-calendar mr-1" }, null, -1));
const _hoisted_18 = { class: "is-flex is-align-items-center" };
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check mr-1" }, null, -1));
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "is-flex-grow-1" }, null, -1));
const _hoisted_21 = {
    key: 0,
    class: "timeDescriptor"
};
const _hoisted_22 = { class: "stageLabel" };
const _hoisted_23 = {
    key: 0,
    class: "statusIcon fas fa-clock"
};
const _hoisted_24 = {
    key: 2,
    class: "statusIcon fas fa-exclamation-triangle"
};
const _hoisted_25 = {
    key: 3,
    class: "statusIcon fas fa-times"
};
const _hoisted_26 = {
    key: 4,
    class: "statusIcon fas fa-check"
};
const _hoisted_27 = { class: "stageDateRow" };
const _hoisted_28 = { key: 0 };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "is-flex-grow-1" }, null, -1));
const _hoisted_30 = { class: "endDate" };
import { computed } from 'vue';
import { formatDateShort, formatDateTime, formatTimeDifference, formatTimeRelativeToNow } from "@/core/utils";
const MILLIS_PER_HOUR = 1000 * 60 * 60;
export default /*#__PURE__*/ _defineComponent({
    __name: 'ProgressIndicator',
    props: {
        startDate: {},
        deliverables: {}
    },
    setup(__props) {
        const props = __props;
        const MILLIS_PER_DAY = MILLIS_PER_HOUR * 24;
        // Calculate more detailed info / deadline status for each deliverable
        const stages = computed(() => {
            const result = [];
            let nextDeliverableStartDate = (props.startDate instanceof Date ? props.startDate.getTime() : props.startDate);
            let prevDeliverableComplete = Boolean(nextDeliverableStartDate);
            for (let idx = 0; idx < props.deliverables.length; ++idx) {
                const deliverable = props.deliverables[idx];
                const startDate = nextDeliverableStartDate;
                const completedDate = deliverable.completedDate instanceof Date ? deliverable.completedDate.getTime() : deliverable.completedDate;
                let status = 'PENDING';
                if (completedDate) {
                    status = 'COMPLETE';
                }
                else {
                    const subsequentDeliverableComplete = props.deliverables.slice(idx + 1).find(d => d.completedDate) !== undefined;
                    if (subsequentDeliverableComplete) {
                        status = 'SKIPPED';
                    }
                    else if (prevDeliverableComplete && startDate) {
                        status = 'IN_PROGRESS';
                    }
                }
                let deadlineDate = undefined;
                let percentTowardsDeadline = undefined;
                if (startDate) {
                    if (deliverable.deadlineHours) {
                        deadlineDate = startDate + deliverable.deadlineHours * MILLIS_PER_HOUR;
                    }
                    else if (deliverable.deadlineDays) {
                        deadlineDate = startDate + deliverable.deadlineDays * MILLIS_PER_DAY;
                    }
                    if (deadlineDate) {
                        const measureTo = completedDate || new Date().getTime();
                        percentTowardsDeadline = 100 * (measureTo - startDate) / (deadlineDate - startDate);
                    }
                }
                // Next deliverable starts after this one ends
                if (completedDate) {
                    nextDeliverableStartDate = completedDate;
                    prevDeliverableComplete = true;
                }
                else {
                    nextDeliverableStartDate = deadlineDate;
                    prevDeliverableComplete = false;
                }
                const message = deliverable.message ? deliverable.message.replace('#DEADLINE#', deliverable.deadlineHours ? `${deliverable.deadlineHours} hours` : `${deliverable.deadlineDays} days`) : '';
                result.push({
                    label: deliverable.label,
                    message: message,
                    status: status,
                    startDate: startDate,
                    deadlineDate: deadlineDate,
                    completedDate: completedDate,
                    endDate: nextDeliverableStartDate,
                    percentTowardsDeadline: percentTowardsDeadline
                });
            }
            console.log(result);
            return result;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stages.value, (stage, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "stage",
                        key: idx
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", null, [
                                _createElementVNode("u", null, _toDisplayString(stage.label), 1)
                            ]),
                            _createElementVNode("div", null, _toDisplayString(stage.message), 1),
                            (stage.status == 'PENDING')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _hoisted_4,
                                    _createTextVNode(" Not yet started ")
                                ]))
                                : _createCommentVNode("", true),
                            (stage.status == 'SKIPPED')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _hoisted_6,
                                    _createTextVNode(" Skipped ")
                                ]))
                                : _createCommentVNode("", true),
                            (stage.status == 'IN_PROGRESS')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _hoisted_9,
                                        _createElementVNode("div", null, "Started " + _toDisplayString(_unref(formatDateTime)(stage.startDate)), 1),
                                        _hoisted_10,
                                        _createElementVNode("div", _hoisted_11, "(" + _toDisplayString(_unref(formatTimeDifference)(stage.startDate, new Date().getTime())) + " ago)", 1)
                                    ]),
                                    (stage.deadlineDate)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _createElementVNode("i", {
                                                class: _normalizeClass(["fas mr-1", stage.percentTowardsDeadline < 100 ? 'fa-clock' : 'fa-exclamation-triangle'])
                                            }, null, 2),
                                            _createElementVNode("div", null, "Due " + _toDisplayString(_unref(formatDateTime)(stage.deadlineDate)), 1),
                                            _hoisted_13,
                                            _createElementVNode("div", _hoisted_14, "(" + _toDisplayString(_unref(formatTimeRelativeToNow)(stage.deadlineDate)) + ")", 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            (stage.status == 'COMPLETE')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    (stage.startDate)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _hoisted_17,
                                            _createElementVNode("div", null, "Started " + _toDisplayString(_unref(formatDateTime)(stage.startDate)), 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_18, [
                                        _hoisted_19,
                                        _createElementVNode("div", null, "Completed " + _toDisplayString(_unref(formatDateTime)(stage.completedDate)), 1),
                                        _hoisted_20,
                                        (stage.startDate)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, "(took " + _toDisplayString(_unref(formatTimeDifference)(stage.startDate, stage.completedDate)) + ")", 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(stage.label), 1),
                        _createElementVNode("div", {
                            class: _normalizeClass(["stageBarWrapper", {
                                    'first': idx == 0,
                                    'last': idx == stages.value.length - 1
                                }])
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["stageBar", [stage.status, {
                                            'late': stage.percentTowardsDeadline && stage.percentTowardsDeadline >= 100
                                        }]])
                            }, [
                                (stage.status == 'IN_PROGRESS' && !stage.percentTowardsDeadline)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                                    : (stage.status == 'IN_PROGRESS' && stage.percentTowardsDeadline < 100)
                                        ? (_openBlock(), _createElementBlock("i", {
                                            key: 1,
                                            class: "statusIcon fas fa-clock",
                                            style: _normalizeStyle({ 'left': `${stage.percentTowardsDeadline * 0.93}%` })
                                        }, null, 4))
                                        : (stage.status == 'IN_PROGRESS' && stage.percentTowardsDeadline >= 100)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                                            : (stage.status == 'SKIPPED')
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                                                : (stage.status == 'COMPLETE')
                                                    ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                                                    : _createCommentVNode("", true)
                            ], 2)
                        ], 2),
                        _createElementVNode("div", _hoisted_27, [
                            (idx == 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(stage.startDate ? _unref(formatDateShort)(stage.startDate) : '???'), 1))
                                : _createCommentVNode("", true),
                            _hoisted_29,
                            _createElementVNode("div", _hoisted_30, _toDisplayString(stage.endDate ? _unref(formatDateShort)(stage.endDate) : '???'), 1)
                        ])
                    ]));
                }), 128))
            ]));
        };
    }
});
